/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/copyUrl';
import './methods/imageLazyLoad.js';
import './methods/openMenu.js';
import './methods/openAudioPlayer.js';
import './methods/newsSwiper.js';
import './methods/swiperLazyLoad.js';
import './methods/multimediaGallery.js';
import './methods/openEmbedVideo.js';
import './methods/projectDetailSwiper.js';
import './methods/openMobileMenuItems.js';
import './methods/aboutVoiceSwiper.js';
import './methods/newsletterSubscribe.js';

/**
 * Plugins
*/
import { SocialShareKit } from 'plugins/social-share-kit';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
    }
});

/* Components */
app.component('ExampleComponent', defineAsyncComponent(() => import('../../components/ExampleComponent.vue')));
app.component('MembersList', defineAsyncComponent(() => import('../../components/MembersList.vue')));
app.component('AboutVoice', defineAsyncComponent(() => import('../../components/AboutVoice.vue')));
app.component('ProgramSearchFilters', defineAsyncComponent(() => import('../../components/ProgramSearchFilters.vue')));
app.component('ProgramPagination', defineAsyncComponent(() => import('../../components/ProgramPagination.vue')));
app.component('ProgramsList', defineAsyncComponent(() => import('../../components/ProgramsList.vue')));

/* Add Pinia store */
import { createPinia } from 'pinia';
const pinia = createPinia();
app.use(pinia);

app.mount('#app');
SocialShareKit.init();
